import { routeData } from "./routes";

export const autoRouteTable = [
    routeData.QUOTE,
    routeData.CAPABILITY_QUESTIONS,
    routeData.MOLDING_QUESTIONS,
    routeData.VEHICLE_PARTS,
    routeData.PART_QUESTIONS,
    routeData.VIN_LOOKUP,
    routeData.ESTIMATE,
    routeData.VEHICLE_DAMAGE,
    routeData.VEHICLE,
];
